import { Card, Chip, Grid } from '@material-ui/core'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import moment from 'moment/moment'
import { ERROR_COLORS, SUCCESS_COLORS, WARNING_COLORS } from 'asterX-UI'
import { useStyles } from './work-list-tasks.styles'
import CardActionArea from '@material-ui/core/CardActionArea'
import { CS_ISSUE_MANAGER } from 'constants/events'

export const WorkListTaksCardDesktop = ({ task, isClosedTasks, onClick }) => {
  const classes = useStyles()

  const isOverdue = task?.end
    ? moment().isAfter(moment(task?.end), 'days')
    : false
  const isCurrentDay = task?.end
    ? moment().date() === moment(task?.end).date()
    : false

  const dateColor = isOverdue
    ? ERROR_COLORS[600]
    : isCurrentDay
    ? WARNING_COLORS[600]
    : SUCCESS_COLORS[600]

  return (
    <Card
      className={
        isOverdue && !isClosedTasks
          ? classes.overdueCard
          : task?.type === CS_ISSUE_MANAGER
          ? classes.csIssueManager
          : ''
      }
      onClick={() => onClick(task)}
    >
      <CardActionArea className={classes.taskCardContent}>
        <Grid container>
          <Grid
            item
            container
            alignItems="center"
            justifyContent="space-between"
          >
            <AsterTypography variant="h6">{task?.title || ''}</AsterTypography>
            {isOverdue && !isClosedTasks && (
              <Chip className={classes.overdueChip} label="Просрочено" />
            )}
          </Grid>
          <Grid item container>
            <Grid item md={3}>
              <FieldInfoNG label="Менеджер" isVertical>
                <AsterTypography>
                  {task?.assignToFullname?.trim() || '-'}
                </AsterTypography>
              </FieldInfoNG>
            </Grid>
            {isClosedTasks ? (
              <Grid item md={3}>
                <FieldInfoNG label="Дата Завершения" isVertical>
                  <AsterTypography
                    style={{
                      color: dateColor
                    }}
                  >
                    {task?.completedDate
                      ? moment(task?.completedDate).format('D MMMM YYYY, HH:mm')
                      : '-'}
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
            ) : (
              <Grid item md={3}>
                <FieldInfoNG label="Дата создания" isVertical>
                  <AsterTypography
                    style={{
                      color: dateColor
                    }}
                  >
                    {task?.start
                      ? moment(task.start).format('D MMMM YYYY, HH:mm')
                      : '-'}
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
            )}
            <Grid item md={3}>
              <FieldInfoNG label="Срок выполнения" isVertical>
                <AsterTypography
                  style={{
                    color: dateColor
                  }}
                >
                  {task?.end
                    ? moment(task.end).format('D MMMM YYYY, HH:mm')
                    : '-'}
                </AsterTypography>
              </FieldInfoNG>
            </Grid>
            <Grid item md={3}>
              <FieldInfoNG label="Описание" isVertical>
                <AsterTypography>
                  {task?.description?.trim() || '-'}
                </AsterTypography>
              </FieldInfoNG>
            </Grid>
          </Grid>
        </Grid>
      </CardActionArea>
    </Card>
  )
}
